import { create } from 'zustand';
import { devtools } from 'zustand/middleware';


type State = {
    printer_left1: string;
    printer_left2: string;
    printer_left3: string;
    printer_left4: string;
    printer_left5: string;
    printer_left6: string;
    printer_left7: string;
    printer_right1: string;
    printer_right2: string;
    printer_right3: string;
    printer_right4: string;
    printer_right5: string;
    printer_right6: string;
    printer_right7: string;
    printer_boolean: boolean;
    printer_logo: string;
    printer_logo_url: string;

};

type Action = {
    updateprinter_left1: (printer_left1: State['printer_left1']) => void;
    updateprinter_left2: (printer_left2: State['printer_left2']) => void;
    updateprinter_left3: (printer_left3: State['printer_left3']) => void;
    updateprinter_left4: (printer_left4: State['printer_left4']) => void;
    updateprinter_left5: (printer_left5: State['printer_left5']) => void;
    updateprinter_left6: (printer_left6: State['printer_left6']) => void;
    updateprinter_left7: (printer_left7: State['printer_left7']) => void;
    updateprinter_right1: (printer_right1: State['printer_right1']) => void;
    updateprinter_right2: (printer_right2: State['printer_right2']) => void;
    updateprinter_right3: (printer_right3: State['printer_right3']) => void;
    updateprinter_right4: (printer_right4: State['printer_right4']) => void;
    updateprinter_right5: (printer_right5: State['printer_right5']) => void;
    updateprinter_right6: (printer_right6: State['printer_right6']) => void;
    updateprinter_right7: (printer_right7: State['printer_right7']) => void;
    updateprinter_boolean: (printer_boolean: State['printer_boolean']) => void;
    updateprinter_logo: (printer_logo: State['printer_logo']) => void;
    updateprinter_logo_url: (printer_logo_url: State['printer_logo_url']) => void;
   
    
};

// Create your store, which includes both state and (optionally) actions
export const usePrinterExtraStore = create<State & Action>()(
    devtools((set) => ({
        printer_left1: "Address: 91-93 Address Rd, London PostCode: N7 ***",
        printer_left2: "Phone: 0208 123 ****",
        printer_left3: "Email: info@yourdomain.com",
        printer_left4: "Website: yourdomain.com",
        printer_left5: "Opening Times: Mon - Fri 9am - 5pm",
        printer_left6: "The text must not exceed seven lines.",
        printer_left7: "",
        printer_right1: "OTHER WAYS TO DONATE: Bank Transfer or Standing Order ",
        printer_right2: "Name Of The Bank Street Name Branch",
        printer_right3: "Sort Code: *** *** ***",
        printer_right4: "Account Number: *** *** ***",
        printer_right5: "You Dont Need All This Information use it as you see Fit",
        printer_right6: "",
        printer_right7: "",
        printer_boolean: false,
        printer_logo: "",
        printer_logo_url: "",

        updateprinter_left1: (printer_left1: string) => set(() => ({ printer_left1: printer_left1 })),
        updateprinter_left2: (printer_left2: string) => set(() => ({ printer_left2: printer_left2 })),
        updateprinter_left3: (printer_left3: string) => set(() => ({ printer_left3: printer_left3 })),
        updateprinter_left4: (printer_left4: string) => set(() => ({ printer_left4: printer_left4 })),
        updateprinter_left5: (printer_left5: string) => set(() => ({ printer_left5: printer_left5 })),
        updateprinter_left6: (printer_left6: string) => set(() => ({ printer_left6: printer_left6 })),
        updateprinter_left7: (printer_left7: string) => set(() => ({ printer_left7: printer_left7 })),
        updateprinter_right1: (printer_right1: string) => set(() => ({ printer_right1: printer_right1 })),
        updateprinter_right2: (printer_right2: string) => set(() => ({ printer_right2: printer_right2 })),
        updateprinter_right3: (printer_right3: string) => set(() => ({ printer_right3: printer_right3 })),
        updateprinter_right4: (printer_right4: string) => set(() => ({ printer_right4: printer_right4 })),
        updateprinter_right5: (printer_right5: string) => set(() => ({ printer_right5: printer_right5 })),
        updateprinter_right6: (printer_right6: string) => set(() => ({ printer_right6: printer_right6 })),
        updateprinter_right7: (printer_right7: string) => set(() => ({ printer_right7: printer_right7 })),
        updateprinter_boolean: (printer_boolean: boolean) => set(() => ({ printer_boolean: printer_boolean })),
        updateprinter_logo: (printer_logo: string) => set(() => ({ printer_logo: printer_logo })),
        updateprinter_logo_url: (printer_logo_url: string) => set(() => ({ printer_logo_url: printer_logo_url })),
        
       

    }),
    { name: 'storePrinterExtra' })
);
